export default "__VITE_ASSET__BH3FM5Lv__"